import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    roleList: {}
}

export const roleSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {
        setRoleList: (state, { payload }) => {
            let { roleList } = payload;
            state.roleList = roleList
        },
    },
})

// Action creators are generated for each case reducer function
export const { setRoleList } = roleSlice.actions

export default roleSlice.reducer